<div *ngIf="showModal">
    <div class="modal-header">
        <h5 class="mb-0">{{ title | translate }} - {{ this.item.id }}</h5>
    </div>
    <div class="modal-body">
        <form class="k-form k-form-md" [formGroup]="form">
            <div class="mb-1 row">
                <div class="col-12 col-md-2 col-xl-2">
                    <app-label controlName="fullName" class="col-form-label">{{ 'common.name' | translate }}</app-label>
                </div>
                <div class="col-12 col-md-10 col-xl-10">
                    <input type="text" id="fullName" formControlName="fullName" class="form-control" />
                    <app-field-error-message controlName="fullName"></app-field-error-message>
                </div>
            </div>
            <div class="mb-1 row">
                <div class="col-12 col-lg-6">
                    <div class="row">
                        <div class="col-12 col-md-4">
                            <app-label controlName="from" class="col-form-label">{{ 'notification.message_from' | translate }}</app-label>
                        </div>
                        <div class="col-12 col-md-8">
                            <input type="text" id="from" formControlName="from" class="form-control" />
                            <app-field-error-message controlName="from"></app-field-error-message>
                        </div>
                    </div>
                </div>

                <div class="col-12 col-lg-6">
                    <div class="row">
                        <div class="col-12 col-md-4">
                            <app-label controlName="type" class="col-form-label">{{ 'notification.message_type_title' | translate }}</app-label>
                        </div>
                        <div class="col-12 col-md-8">
                            <input type="text" id="type" class="form-control" disabled [value]="getValueFromEnum('type') | translate" />
                            <app-field-error-message controlName="type"></app-field-error-message>
                        </div>
                    </div>
                </div>
            </div>
            <div class="mb-1 row">
                <div class="col-12 col-lg-6">
                    <div class="row">
                        <div class="col-12 col-md-4 col-xl-4">
                            <app-label controlName="status" class="col-form-label">{{ 'common.status' | translate }}</app-label>
                        </div>
                        <div class="col-12 col-md-8 col-xl-8">
                            <input type="text" id="status" class="form-control" disabled [value]="getValueFromEnum('status') | translate" />
                            <app-field-error-message controlName="status"></app-field-error-message>
                        </div>
                    </div>
                </div>

                <div class="col-12 col-lg-6">
                    <div class="row">
                        <div class="col-12 col-md-4 col-xl-4">
                            <app-label controlName="sentType" class="col-form-label">{{ 'notification.message_sent_type_title' | translate }}</app-label>
                        </div>
                        <div class="col-12 col-md-8 col-xl-8">
                            <input type="text" id="sentType" class="form-control" disabled [value]="getValueFromEnum('sentType') | translate" />
                            <app-field-error-message controlName="sentType"></app-field-error-message>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mb-1">
                <div class="col-12 col-md-6" *ngIf="!isEmailEmpty">
                    <div class="row">
                        <div class="col-12 col-md-4">
                            <app-label controlName="email" class="col-form-label">{{ 'common.email' | translate }}</app-label>
                        </div>
                        <div class="col-12 col-md-8">
                            <input type="text" id="email" formControlName="email" class="form-control" />
                            <app-field-error-message controlName="email"></app-field-error-message>
                        </div>
                    </div>
                </div>

                <div [ngClass]="!isEmailEmpty ? 'col-12 col-md-6' : 'col-12'">
                    <div class="row">
                        <div [ngClass]="!isEmailEmpty ? 'col-12 col-md-4' : 'col-12 col-md-2'">
                            <app-label controlName="subject" class="col-form-label">{{ 'common.subject' | translate }}</app-label>
                        </div>
                        
                        <div [ngClass]="!isEmailEmpty ? 'col-12 col-md-8' : 'col-12 col-md-10'">
                            <input type="text" id="subject" formControlName="subject" class="form-control" />
                            <app-field-error-message controlName="subject"></app-field-error-message>
                        </div>
                    </div>
                </div>
            </div>
            <div class="mb-1 row" *ngIf="isEmailType">
                <div class="col-12 col-md-2 col-xl-2">
                    <app-label controlName="attachments" class="col-form-label">{{ 'notification.email_attachments' | translate }}</app-label>
                </div>
                <div class="col-12 col-md-10 col-xl-10">
                    <input type="text" id="attachments" formControlName="attachments" class="form-control" />
                    <app-field-error-message controlName="attachments"></app-field-error-message>
                </div>
            </div>
            <div class="mb-1 row">
                <div class="col-12 col-md-2 col-xl-2">
                    <app-label controlName="body" class="col-form-label">{{ 'common.body' | translate }}</app-label>
                </div>
                <div class="col-12 col-md-10 col-xl-10">
                    <textarea rows="10" class="form-control" formControlName="body"></textarea>
                    <app-field-error-message controlName="body"></app-field-error-message>
                </div>
            </div>
            <hr />
            <div class="mb-1 row">
                <div class="d-flex justify-content-center mb-1 row w-100">
                    <div class="col-12 col-md-2 col-xl-2">
                        <button class="btn btn-secondary w-100" (click)="onDelete()">
                            {{ 'common.delete' | translate }}
                        </button>
                    </div>
                    <div class="col-12 col-md-2 col-xl-2" *ngIf="isEmailType">
                        <button class="btn btn-primary w-100" (click)="onOpenEmailView()">
                            {{ 'common.view' | translate }}
                        </button>
                    </div>
                    <div class="col-12 col-md-2 col-xl-2">
                        <button class="btn btn-secondary w-100" (click)="onClose()">
                            {{ 'common.cancel' | translate }}
                        </button>
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>
